import React, { useRef, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { handleGoToPdf } from '../../utils/handleGoToPdf'
import 'antd/dist/antd.css';
import './nodes.css';
import { Map } from '../../components/DrawMap';
import { Navbar } from '../../components/Navbar';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { apiNodePointsActions, nodePoints } from '../../features/api_node_points/apiNodePointsSlice';
import { SnackbarCloseReason } from '@mui/material/Snackbar';
import { ItineraryMenu } from '../../components/ItineraryMenu';
import { GPXDownloadButton } from '../../components/GPXDownloadButton';
import { PDFDownloadButton } from '../../components/PDFDownloadButton';
import { PathSegment } from '../../types/types'
import { downloadGPX } from '../../utils/downloadGpx'
import { NodePointListView } from '../../components/interestPointListView/interestPointListView'
import { BottomSheet, BottomSheetRef } from 'react-spring-bottom-sheet'
import 'react-spring-bottom-sheet/dist/style.css'




export const ListNodePointsLayout: React.FC = () => {
  const dispatch = useDispatch();
  const nodes = useSelector(nodePoints);
  const [nodeIdsSelected, setNodeIdsSelected] = useState<Array<string>>([]);
  const [confirmModal, setConfirmModal] = useState(false)
  const [itinerarySequence, setItinerarySequence] = useState<string[]>([]);
  const [distance, setDistance] = useState<number>(0);
  const [open, setOpen] = React.useState(false);
  const [pathCoords, setPathCoords] = useState<Array<PathSegment>>([]);
  const [showItinerary, setShowItinerary] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [pointInterestSelected, setPointInterestSelected] = useState<string | null>(null);
  const sheetRef = useRef<BottomSheetRef>(null);

  const navigate = useNavigate();



  const onCollapse = (collapsed: boolean) => {
    console.log(collapsed);
  };

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (
    event: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  const closeModal = () => {
    setConfirmModal(false);
  };

  const openModal = () => {
    setConfirmModal(true);
  }

  const deleteAll = () => {
    setItinerarySequence([])
    setPathCoords([])
    setShowItinerary(false)
  };

  const showRoute = () => {
    setShowItinerary(!showItinerary)
  };


  useEffect(() => {
    const checkMobile = () => {
      const screenWidth = window.innerWidth <= 768;
      const isMobileDevice = screenWidth;

      setIsMobile(isMobileDevice);
      console.log(isMobileDevice)
    };

    // Check on mount
    checkMobile();

    // Listen for resize events
    window.addEventListener('resize', checkMobile);

    // Cleanup
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const styles = {
    overflow: 'auto',
    height: '95vh',
  };

  useEffect(() => { dispatch(apiNodePointsActions.fetchGetNodePoints({})); }, []);


  const handleClickInterestSelected = (idPointInterest: string) => {
    setPointInterestSelected(idPointInterest)
  };


  const selectNodePoint = (idNodePoint: string) => {
    setNodeIdsSelected(prev => {
      if (prev.includes(idNodePoint)) {
        return prev.filter(id => id !== idNodePoint);
      }
      return [...prev, idNodePoint];
    });
  }
  const toggleRoutePoint = (e: any) => {
    console.log(`Toggling route point ${e}`);

  };


  useEffect(() => {
    let totalDistance = 0;
    for (const segment of pathCoords) {
      totalDistance += segment.distance;
    }
    const distanceInKm = totalDistance / 1000;
    setDistance(distanceInKm);
  }, [pathCoords]

  )

  const handleItinerarySequence = (nodeId: string) => {
    console.log('Marker clicked', nodeId)
    setItinerarySequence(prev =>
      prev.at(-1) === nodeId ? prev.slice(0, -1) : [...prev, nodeId]
    )
  }

  return (
    <div className='node-container'>
      <Navbar />
      {itinerarySequence.length === 0 && (
        <div className='instruction-banner'>
          <span>Selecciona primero un punto nodal para personalizar tu ruta.</span>
        </div>
      )}

      {itinerarySequence.length > 1 && (
        <div className='btns-download'>
          <GPXDownloadButton onClick={() => downloadGPX(pathCoords, itinerarySequence)}>GPX</GPXDownloadButton>
          <PDFDownloadButton onClick={() => handleGoToPdf(itinerarySequence, pathCoords, navigate)}>PDF</PDFDownloadButton>
        </div>
      )}

      <div className='map-and-menu'>
        {isMobile ? (
          <BottomSheet
            open={true}
            ref={sheetRef}
            blocking={false}
            snapPoints={({ maxHeight }) => [maxHeight / 9, maxHeight * 0.6]}
          >
            <ItineraryMenu
              currentSequence={itinerarySequence}
              pathCoords={pathCoords}
              setCurrentSequence={setItinerarySequence}
              setPathCoords={setPathCoords}
              setShowItinerary={setShowItinerary}
              isCollapsed={isCollapsed}
              setIsCollapsed={setIsCollapsed}
            />
          </BottomSheet>
        ) : (
            <div className="sider" style={{ height: isCollapsed ? '140px' : '' }}>
              <ItineraryMenu
                currentSequence={itinerarySequence}
                pathCoords={pathCoords}
                setCurrentSequence={setItinerarySequence}
                setPathCoords={setPathCoords}
                setShowItinerary={setShowItinerary}
                isCollapsed={isCollapsed}
                setIsCollapsed={setIsCollapsed}
              />
            </div>
          )}
        <Map
          onPointInterestSelected={handleClickInterestSelected}
          isMapClicked={true}
          showSnackbar={handleClick}
          onMarkerClick={handleItinerarySequence}
          currentSequence={itinerarySequence}
          setCurrentSequence={setItinerarySequence}
          pathCoords={pathCoords}
          setPathCoords={setPathCoords}
          pointInterestSelected={pointInterestSelected}
        />
      </div>
    </div>
  );
}




